import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useBreakpoint } from "@hooks/useBreakpoint";
import { updateCurrentBreakpoint } from "./layoutSlice";

const BreakpointWatcher = () => {
  const dispatch = useDispatch();
  const { current } = useBreakpoint();

  useEffect(() => {
    dispatch(updateCurrentBreakpoint(current));
  }, [current, dispatch]);

  return null;
};

export default BreakpointWatcher;
